(() => {
  const initialized = new WeakSet();

  const initRail = (rail) => {
    const slides = [...rail.querySelectorAll('[data-scc-menu-slide]')];
    const dots = [...rail.parentElement.querySelectorAll('[data-scc-menu-dot]')];
    if (slides.length < 2 || dots.length === 0 || initialized.has(rail) || !rail.clientWidth) return;
    initialized.add(rail);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let ticking = false;
    let pageCount = 1;
    let visibleSlides = 1;
    let slideStep = 0;

    const update = () => {
      if (!slideStep || !pageCount) return;
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const targetOffsets = Array.from({ length: pageCount }, (_, index) => {
        const targetIndex = Math.min(slides.length - visibleSlides, index * visibleSlides);
        return Math.min(maxScroll, Math.max(0, slides[targetIndex].offsetLeft - slides[0].offsetLeft));
      });
      const nearestPage = targetOffsets.reduce((nearest, offset, index) => (
        Math.abs(offset - rail.scrollLeft) < Math.abs(targetOffsets[nearest] - rail.scrollLeft) ? index : nearest
      ), 0);
      dots.forEach((dot, index) => {
        if (index < pageCount) dot.setAttribute('aria-current', String(index === nearestPage));
      });
      ticking = false;
    };

    const refresh = () => {
      if (!rail.clientWidth || !slides[0]) return;
      slideStep = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].getBoundingClientRect().width;
      if (slideStep <= 0) return;
      const gap = slideStep - slides[0].getBoundingClientRect().width;
      visibleSlides = Math.min(slides.length, Math.max(1, Math.floor((rail.clientWidth + gap) / slideStep)));
      pageCount = Math.max(1, Math.ceil(slides.length / visibleSlides));
      dots.forEach((dot, index) => {
        const active = index < pageCount;
        dot.hidden = !active;
        dot.tabIndex = active ? 0 : -1;
        dot.setAttribute('aria-hidden', String(!active));
        if (active) dot.setAttribute('aria-label', `Show featured collection page ${index + 1} of ${pageCount}`);
      });
      update();
    };

    rail.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      if (index >= pageCount) return;
      const targetIndex = Math.min(slides.length - visibleSlides, index * visibleSlides);
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const left = Math.min(maxScroll, Math.max(0, slides[targetIndex].offsetLeft - slides[0].offsetLeft));
      rail.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }));
    if ('ResizeObserver' in window) new ResizeObserver(refresh).observe(rail);
    refresh();
  };

  const init = () => document.querySelectorAll('[data-scc-menu-rail]').forEach(initRail);
  document.addEventListener('toggle', init, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
